import { Component, OnInit, ViewChild, TemplateRef, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { ProcessoConsulta } from '@app/models/processo.model';
import { TitulosVinculadosProcesso, VincularDivisaoInput } from '@app/models/receber-divisao-honorarios.model';
import { Paginacao } from '@app/models/util/paginacao';
import { DivisaoHonorariosService } from '@app/services/divisao-honorarios.service';
import { ImportacaoPublicacaoService } from '@app/services/importar-publicacao.service';
import { Toast, ToastrService } from 'ngx-toastr';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { BuscarProcessosModel } from '@app/pages/processos/buscar-processos/model';

@Component({
  selector: 'app-divisao-honorarios-vincular',
  templateUrl: './divisao-honorarios-vincular.component.html'
})
export class DivisaoHonorariosVincularComponent implements OnInit {
  @ViewChild('modalConfirmaPercentualVinculo', { static: true }) confirmaPercentualVinculoRef: TemplateRef<any>;
  modalConfirmaPercentualVinculo: BsModalRef;

  paginacao: Paginacao = new Paginacao();
  pesquisando: boolean = false;
  finalizando: boolean = false;
  filtroDescricao = '';
  lstProcesso: ProcessoConsulta[] = [];
  titulosProcesso: TitulosVinculadosProcesso = new TitulosVinculadosProcesso();
  buscarProcessosModel: BuscarProcessosModel = new BuscarProcessosModel();

  lstVinculo: TitulosVinculadosProcesso = new TitulosVinculadosProcesso();

  divisaoVincular: VincularDivisaoInput = new VincularDivisaoInput();
  totaisAdvogados = [];

  
  constructor(
    private importacaoPublicacaoService: ImportacaoPublicacaoService,
    private divisaoHonorariosService: DivisaoHonorariosService,
    private modalService: BsModalService,
    private router: Router,
    @Inject(ToastrService) public toastr: ToastrService) { }

  settarSobrePagar(pagarId: number){
    let pagarModel = this.lstVinculo.ListaPagar.find(x => x.Id === pagarId);
    let pagarVinculo = this.titulosProcesso.ListaPagar.find(x => x.Id === pagarId);
  
    switch(pagarModel.SobreTipo){
      case 'A':{
        pagarModel.SobreAdvogado = pagarVinculo.SobreAdvogado = true;
        pagarModel.SobreSubstabelecido = pagarVinculo.SobreSubstabelecido = false;
        pagarModel.SobreDespesas = pagarVinculo.SobreDespesas = false;
        break;
      }

      case 'S':{
        pagarModel.SobreAdvogado = pagarVinculo.SobreAdvogado = false;
        pagarModel.SobreSubstabelecido = pagarVinculo.SobreSubstabelecido = true;
        pagarModel.SobreDespesas = pagarVinculo.SobreDespesas = false;
        break;
      }

      case 'D':{
        pagarModel.SobreAdvogado = pagarVinculo.SobreAdvogado = false;
        pagarModel.SobreSubstabelecido = pagarVinculo.SobreSubstabelecido = false;
        pagarModel.SobreDespesas = pagarVinculo.SobreDespesas = true;
        break;
      }

      default:{
        pagarModel.SobreAdvogado = pagarVinculo.SobreAdvogado = false;
        pagarModel.SobreSubstabelecido = pagarVinculo.SobreSubstabelecido = false;
        pagarModel.SobreDespesas = pagarVinculo.SobreDespesas = false;
        break;
      }
        
    }
  }

  finalizar(){
    this.finalizando = false;

    this.divisaoVincular.ReceberLista = this.lstVinculo.ListaReceber;
    this.divisaoVincular.PagarLista = this.lstVinculo.ListaPagar;
    
    //foreach receber
    let totalEscritorio = 0;
    let totalCliente = 0;
    this.divisaoVincular.ReceberLista.forEach(
      receber => {
        if(receber.DemonstrativoDeResultadoId === 5 && !receber.ReferenciaId)
          totalEscritorio += receber.Valor;

        if(receber.DemonstrativoDeResultadoId === 3 && !receber.ReferenciaId)
          totalCliente += receber.Valor;
    });
    
    let totalDivisao = totalEscritorio + totalCliente;
    this.divisaoVincular.EscritorioPercentual = Number((totalEscritorio / totalDivisao * 100).toFixed(2));
    this.divisaoVincular.ClientePercentual = Number((100 - this.divisaoVincular.EscritorioPercentual).toFixed(2));

    //foreach pagar
    let totalDespesas = 0;
    let totalSubstabelecido = 0;;
    this.divisaoVincular.PagarLista.forEach(
      pagar => {
        if(pagar.SobreDespesas && !pagar.ReferenciaId)
          totalDespesas += pagar.Valor;

        if(pagar.SobreSubstabelecido && !pagar.ReferenciaId)
          totalSubstabelecido += pagar.Valor;

        if(pagar.SobreAdvogado && !pagar.ReferenciaId){          
          if(!this.totaisAdvogados.find(x => x.AdvogadoId === pagar.ParticipanteId)){
            let infosAdvogado = {
              AdvogadoId: pagar.ParticipanteId,
              AdvogadoNome: pagar.Participante.NomeFantasia,
              Valor: pagar.Valor,
              Percentual: 0
            };
            this.totaisAdvogados.push(infosAdvogado);
          } else {
            this.totaisAdvogados.find(x => x.AdvogadoId === pagar.ParticipanteId).Valor += pagar.Valor;
          }
        }
    });

    this.divisaoVincular.DespesaPercentual = Number((totalDespesas / totalEscritorio * 100).toFixed(2));
    this.divisaoVincular.SubstabelecidoPercentual = Number((totalSubstabelecido / totalDivisao * 100).toFixed(2));
    this.totaisAdvogados.forEach(
      advogado => {
        advogado.Percentual = Number((advogado.Valor / totalEscritorio * 100).toFixed(2));
    });

    this.modalConfirmaPercentualVinculo = this.modalService.show(this.confirmaPercentualVinculoRef, {
      keyboard: false,
      ignoreBackdropClick: true
    });

    this.finalizando = false;
  }

  sanitizar(){
    if(this.divisaoVincular.EscritorioPercentual.toString().indexOf(','))
      this.divisaoVincular.EscritorioPercentual = Number(this.divisaoVincular.EscritorioPercentual.toString().replace(',', '.'));
    if(this.divisaoVincular.ClientePercentual.toString().indexOf(','))
      this.divisaoVincular.ClientePercentual = Number(this.divisaoVincular.ClientePercentual.toString().replace(',', '.'));
  }

  completaCliente() {
    this.sanitizar();
    this.divisaoVincular.ClientePercentual = Number((100 - this.divisaoVincular.EscritorioPercentual).toFixed(2));
  }

  completaEscritorio() {
    this.sanitizar();
    this.divisaoVincular.EscritorioPercentual = Number((100 - this.divisaoVincular.ClientePercentual).toFixed(2));
  }

  realizarVinculo(){
    this.finalizando = true;

    this.totaisAdvogados.forEach(advogado => {
      this.divisaoVincular.AdvogadosHonorarios.set(advogado.AdvogadoId, advogado.Percentual);
    });

    this.divisaoHonorariosService.VincularDivisaoHonorarios(this.divisaoVincular).subscribe(
      (data) => {
        this.toastr.success('Vínculo realizado com sucesso!');
        this.titulosProcesso = new TitulosVinculadosProcesso();
        this.lstVinculo = new TitulosVinculadosProcesso();
        this.modalConfirmaPercentualVinculo.hide();
        this.router.navigate(['financeiro/divisaoHonorarios/detalharDivisao', data.Id]);
      },
      (erro) => {
        this.toastr.error(erro.error.errors[0]);
        this.finalizando = false;
      }
    )

  }

  vincularProcesso(processoId: number, clienteId: number) {
    this.lstProcesso = [];

    this.divisaoVincular.ProcessoId = processoId;
    this.divisaoVincular.ClienteId = clienteId;

    this.divisaoHonorariosService.BuscarTitulosVinculadosDoProcesso(processoId).toPromise().then(
      data => {
        this.titulosProcesso = data;
      }, error => {
        this.toastr.warning('Realize a pesquisa novamente.');
      }
    );
  }

  verificaCondicaoVincularTitulo(receber){
    return !receber.ReferenciaId && receber.Id == receber.Numero && !receber.Vinculado;
  }
  vincularTitulo(receberId: number){
    let receber = this.titulosProcesso.ListaReceber.find(x => x.Id === receberId);
    receber.Vinculado = true;
    this.lstVinculo.ListaReceber.push(receber);

    let ultimoTituloId = receber.Id;
    let parcial = this.titulosProcesso.ListaReceber.find(x => x.ReferenciaId === ultimoTituloId);
    
    while(parcial !== null && parcial !== undefined){
      ultimoTituloId = parcial.Id;
      this.lstVinculo.ListaReceber.push(parcial);
      parcial = this.titulosProcesso.ListaReceber.find(x => x.ReferenciaId === ultimoTituloId);
    }

    let pagarVinculados = this.titulosProcesso.ListaPagar.filter(x => x.ReceberReferenciaId === receber.Id);
    pagarVinculados.forEach(pagarVinculado => {
      pagarVinculado.SobreTipo = '';
      this.lstVinculo.ListaPagar.push(pagarVinculado);

      if(receber.CreditoCliente === null || receber.CreditoCliente === undefined){
        pagarVinculado.SetSobre = true;
      }

      let pagarParciais = this.titulosProcesso.ListaPagar.filter(x => x.ReferenciaId === pagarVinculado.Id);
      pagarParciais.forEach(pagarParcial => this.lstVinculo.ListaPagar.push(pagarParcial));  
    
    });
  }

  desvincularTitulo(receberId: number){
    let receber = this.titulosProcesso.ListaReceber.find(x => x.Id === receberId);
    receber.Vinculado = false;

    this.lstVinculo.ListaReceber = this.lstVinculo.ListaReceber.filter(x => x.Id !== receberId);

    let ultimoTituloId = receberId;
    let acabouLoop = false;

    while(!acabouLoop){
      let parcial = this.lstVinculo.ListaReceber.find(x => x.ReferenciaId === ultimoTituloId);
      if(parcial === null || parcial === undefined){
        acabouLoop = true;
        continue;
      }
      this.lstVinculo.ListaReceber = this.lstVinculo.ListaReceber.filter(x => x.Id !== parcial.Id);
      
      ultimoTituloId = parcial.Id;
    }

    let pagarVinculados = this.lstVinculo.ListaPagar.filter(x => x.ReceberReferenciaId === receberId);
    pagarVinculados.forEach(pagarVinculado => {
      pagarVinculado.SobreSubstabelecido = false;
      pagarVinculado.SobreDespesas = false;
      pagarVinculado.SobreAdvogado = false;
      pagarVinculado.SetSobre = false;
      this.lstVinculo.ListaPagar = this.lstVinculo.ListaPagar.filter(x => x.Id !== pagarVinculado.Id && x.ReferenciaId !== pagarVinculado.Id);  
    });
  }

  pesquisar() {
    this.pesquisando = true;
    this.obterTodosProcessos(this.filtroDescricao, 1);
    this.paginacao.paginaAtual = 1;
  }


  obterTodosProcessos(descricao: string, pagina: number) {
    this.buscarProcessosModel.FiltroDescricao = descricao;
    this.importacaoPublicacaoService.buscaProcesso(this.buscarProcessosModel)
      .subscribe(data => {
        if(data.Dados.length === 0)
          this.toastr.info('Não há processos para a pesquisa realizada!');
        
        this.lstProcesso = data.Dados,
        this.paginacao.totalDeItens = data.Total;
        this.pesquisando = false;
      },
        erro => {
          this.toastr.error('Erro ao realizar pesquisa!');
          this.pesquisando = false;
        }
      );
  }

  public pageChanged(event: any): void {
    this.obterTodosProcessos(this.filtroDescricao, event.page);
  }

  ngOnInit(): void {
  }

}
